import { Carousel, SimpleSlide } from 'src/components/Carousel';
import Cta from 'src/components/cta';
import FeatureSectionUsecases from 'src/components/features/feature-section-usecases';
import PageHeader from 'src/components/headers/page-header';
import { IntroSection } from 'src/components/Layout/IntroSection';
import Quote from 'src/components/quote';
import SocialProof from 'src/components/social-proof';

import { Locales } from 'src/lib/constants';

// data
import {
  ctaData,
  featureSectionData,
  introSectionData,
  metaData,
  pageHeaderData,
  quoteData,
  simpleCarouselData,
  socialProofData,
} from 'src/store/en-gb/use-cases/personal-finances';

import { UseCaseTemplate } from 'src/templates';

export default ({ locale = Locales.EN_GB }) => {
  return (
    <UseCaseTemplate fields={metaData} locale={locale}>
      <PageHeader {...pageHeaderData} />
      <SocialProof {...socialProofData} />
      <IntroSection {...introSectionData} />
      <Quote {...quoteData} />
      <FeatureSectionUsecases {...featureSectionData} />
      <Carousel>
        {simpleCarouselData['carousel-slides'].map((slide) => {
          return (
            <SimpleSlide
              carouselTitle={simpleCarouselData['carousel-title']}
              {...slide}
            />
          );
        })}
      </Carousel>
      <Cta {...ctaData} />
    </UseCaseTemplate>
  );
};
